import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled.div`
  position: relative;
`;
const Children = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  position: absolute;
  inset: 0;
  align-items: center;
`;

type Props = { border?: boolean; children?: ReactNode };

export const XPHexagon = ({ border, children }: Props) => {
  return (
    <Root>
      <svg
        width="57"
        height="66"
        viewBox="0 0 57 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M4.19702e-06 16.9917L1.39949e-06 48.9917L28 65L56 48.9917L56 16.9917L28 0.999998L4.19702e-06 16.9917Z"
            fill="url(#paint0_linear_8100_34728)"
          />
          <mask
            id="mask0_8100_34728"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="56"
            height="64"
          >
            <path
              d="M4.19702e-06 16.9917L1.39949e-06 48.9917L28 65L56 48.9917L56 16.9917L28 0.999998L4.19702e-06 16.9917Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_8100_34728)">
            <g style={{ mixBlendMode: 'overlay' }} opacity="0.4">
              <mask
                id="mask1_8100_34728"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="-34"
                y="-22"
                width="124"
                height="109"
              >
                <mask
                  id="mask2_8100_34728"
                  style={{ maskType: 'alpha' }}
                  maskUnits="userSpaceOnUse"
                  x="-34"
                  y="-22"
                  width="124"
                  height="109"
                >
                  <rect
                    x="89.1704"
                    y="-21.5688"
                    width="108.506"
                    height="122.774"
                    rx="15.5905"
                    transform="rotate(90 89.1704 -21.5688)"
                    fill="#090909"
                  />
                </mask>
                <g mask="url(#mask2_8100_34728)">
                  <path
                    d="M70.5902 41.8036L53.5986 45.7276L61.9698 37.0166L70.5902 41.8036Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M70.5902 41.8036L53.5986 45.7276L61.9698 37.0166L70.5902 41.8036Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M61.7091 51.0451L44.7175 54.9691L53.0887 46.2581L61.7091 51.0451Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M61.7091 51.0451L44.7175 54.9691L53.0887 46.2581L61.7091 51.0451Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M52.8282 60.2865L35.8367 64.2105L44.2079 55.4995L52.8282 60.2865Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M52.8282 60.2865L35.8367 64.2105L44.2079 55.4995L52.8282 60.2865Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M43.9475 69.528L26.9527 73.4552L35.327 64.741L43.9475 69.528Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M43.9475 69.528L26.9527 73.4552L35.327 64.741L43.9475 69.528Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M70.969 56.1873L53.9742 60.1097L62.3455 51.3986L70.969 56.1873Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M70.969 56.1873L53.9742 60.1097L62.3455 51.3986L70.969 56.1873Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M62.0882 65.4287L45.0933 69.351L53.4646 60.6399L62.0882 65.4287Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M62.0882 65.4287L45.0933 69.351L53.4646 60.6399L62.0882 65.4287Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M69.6297 -1.2543L52.6348 2.66805L61.0061 -6.04306L69.6297 -1.2543Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M69.6297 -1.2543L52.6348 2.66805L61.0061 -6.04306L69.6297 -1.2543Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M60.7488 7.98715L43.754 11.9095L52.1253 3.19839L60.7488 7.98715Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M60.7488 7.98715L43.754 11.9095L52.1253 3.19839L60.7488 7.98715Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M51.8678 17.2287L34.8698 21.1542L43.2441 12.4398L51.8678 17.2287Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M51.8678 17.2287L34.8698 21.1542L43.2441 12.4398L51.8678 17.2287Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M42.9837 26.4734L25.9888 30.3957L34.3601 21.6846L42.9837 26.4734Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M42.9837 26.4734L25.9888 30.3957L34.3601 21.6846L42.9837 26.4734Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M34.1028 35.7149L17.108 39.6373L25.4793 30.9262L34.1028 35.7149Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M34.1028 35.7149L17.108 39.6373L25.4793 30.9262L34.1028 35.7149Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M25.2217 44.9563L8.22688 48.8786L16.5982 40.1675L25.2217 44.9563Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M25.2217 44.9563L8.22688 48.8786L16.5982 40.1675L25.2217 44.9563Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M16.3409 54.1978L-0.657106 58.1233L7.71729 49.409L16.3409 54.1978Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M16.3409 54.1978L-0.657106 58.1233L7.71729 49.409L16.3409 54.1978Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M7.45681 63.4426L-9.53801 67.3649L-1.16674 58.6538L7.45681 63.4426Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M7.45681 63.4426L-9.53801 67.3649L-1.16674 58.6538L7.45681 63.4426Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M70.0057 13.1276L53.0142 17.0516L61.3854 8.34059L70.0057 13.1276Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M70.0057 13.1276L53.0142 17.0516L61.3854 8.34059L70.0057 13.1276Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M61.1247 22.3691L44.13 26.2963L52.5043 17.582L61.1247 22.3691Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M61.1247 22.3691L44.13 26.2963L52.5043 17.582L61.1247 22.3691Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M52.2406 31.6138L35.249 35.5378L43.6202 26.8268L52.2406 31.6138Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M52.2406 31.6138L35.249 35.5378L43.6202 26.8268L52.2406 31.6138Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M43.3597 40.8554L26.3682 44.7794L34.7394 36.0684L43.3597 40.8554Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M43.3597 40.8554L26.3682 44.7794L34.7394 36.0684L43.3597 40.8554Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M34.4786 50.0967L17.4871 54.0207L25.8583 45.3097L34.4786 50.0967Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M34.4786 50.0967L17.4871 54.0207L25.8583 45.3097L34.4786 50.0967Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M25.5978 59.3382L8.60311 63.2654L16.9774 54.5512L25.5978 59.3382Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M25.5978 59.3382L8.60311 63.2654L16.9774 54.5512L25.5978 59.3382Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M16.7137 68.583L-0.277792 72.507L8.09337 63.796L16.7137 68.583Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M16.7137 68.583L-0.277792 72.507L8.09337 63.796L16.7137 68.583Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M70.3846 27.5112L53.3866 31.4368L61.761 22.7224L70.3846 27.5112Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M70.3846 27.5112L53.3866 31.4368L61.761 22.7224L70.3846 27.5112Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M61.5005 36.756L44.5057 40.6783L52.877 31.9672L61.5005 36.756Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M61.5005 36.756L44.5057 40.6783L52.877 31.9672L61.5005 36.756Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M52.6197 45.9975L35.6248 49.9199L43.9961 41.2088L52.6197 45.9975Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M52.6197 45.9975L35.6248 49.9199L43.9961 41.2088L52.6197 45.9975Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M43.7385 55.239L26.7437 59.1613L35.115 50.4502L43.7385 55.239Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M43.7385 55.239L26.7437 59.1613L35.115 50.4502L43.7385 55.239Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M34.8578 64.4804L17.8597 68.4059L26.2341 59.6916L34.8578 64.4804Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M34.8578 64.4804L17.8597 68.4059L26.2341 59.6916L34.8578 64.4804Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M33.0867 -7.37405L16.0918 -3.45169L24.4631 -12.1628L33.0867 -7.37405Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M33.0867 -7.37405L16.0918 -3.45169L24.4631 -12.1628L33.0867 -7.37405Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M24.2059 1.86757L7.20792 5.79308L15.5823 -2.92124L24.2059 1.86757Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M24.2059 1.86757L7.20792 5.79308L15.5823 -2.92124L24.2059 1.86757Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M15.3216 11.1123L-1.67329 15.0346L6.69801 6.32351L15.3216 11.1123Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M15.3216 11.1123L-1.67329 15.0346L6.69801 6.32351L15.3216 11.1123Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M6.4407 20.3537L-10.5542 24.2761L-2.18285 15.565L6.4407 20.3537Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M6.4407 20.3537L-10.5542 24.2761L-2.18285 15.565L6.4407 20.3537Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M42.3435 -2.23355L25.3487 1.68881L33.72 -7.02232L42.3435 -2.23355Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M42.3435 -2.23355L25.3487 1.68881L33.72 -7.02232L42.3435 -2.23355Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M33.4625 7.00795L16.4645 10.9335L24.8389 2.21914L33.4625 7.00795Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M33.4625 7.00795L16.4645 10.9335L24.8389 2.21914L33.4625 7.00795Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M24.5784 16.2527L7.58354 20.175L15.9548 11.4639L24.5784 16.2527Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M24.5784 16.2527L7.58354 20.175L15.9548 11.4639L24.5784 16.2527Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M15.6975 25.4942L-1.29732 29.4166L7.07398 20.7055L15.6975 25.4942Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M15.6975 25.4942L-1.29732 29.4166L7.07398 20.7055L15.6975 25.4942Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M6.81643 34.7356L-10.1784 38.6579L-1.80713 29.9468L6.81643 34.7356Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M6.81643 34.7356L-10.1784 38.6579L-1.80713 29.9468L6.81643 34.7356Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M60.4813 -6.33458L43.4898 -2.41056L51.861 -11.1216L60.4813 -6.33458Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M60.4813 -6.33458L43.4898 -2.41056L51.861 -11.1216L60.4813 -6.33458Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M51.6004 2.90688L34.6089 6.83091L42.9801 -1.88011L51.6004 2.90688Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M51.6004 2.90688L34.6089 6.83091L42.9801 -1.88011L51.6004 2.90688Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M42.7194 12.1484L25.7247 16.0756L34.099 7.36134L42.7194 12.1484Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M42.7194 12.1484L25.7247 16.0756L34.099 7.36134L42.7194 12.1484Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M33.8353 21.3931L16.8438 25.3171L25.215 16.6061L33.8353 21.3931Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M33.8353 21.3931L16.8438 25.3171L25.215 16.6061L33.8353 21.3931Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M24.9542 30.6347L7.96266 34.5587L16.3339 25.8477L24.9542 30.6347Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M24.9542 30.6347L7.96266 34.5587L16.3339 25.8477L24.9542 30.6347Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M16.0733 39.8761L-0.91817 43.8001L7.45299 35.0891L16.0733 39.8761Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M16.0733 39.8761L-0.91817 43.8001L7.45299 35.0891L16.0733 39.8761Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M7.19257 49.1175L-9.80216 53.0447L-1.42787 44.3305L7.19257 49.1175Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M7.19257 49.1175L-9.80216 53.0447L-1.42787 44.3305L7.19257 49.1175Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M15.1129 -3.18187L-1.8851 0.743646L6.48927 -7.97067L15.1129 -3.18187Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M15.1129 -3.18187L-1.8851 0.743646L6.48927 -7.97067L15.1129 -3.18187Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                  <path
                    d="M6.22878 6.06296L-10.7661 9.98533L-2.39476 1.2742L6.22878 6.06296Z"
                    fill="#00160F"
                    fillOpacity="0.3"
                  />
                  <path
                    d="M6.22878 6.06296L-10.7661 9.98533L-2.39476 1.2742L6.22878 6.06296Z"
                    stroke="#00DBB1"
                    strokeWidth="0.386515"
                  />
                </g>
              </mask>
              <g mask="url(#mask1_8100_34728)">
                <ellipse
                  cx="27.9928"
                  cy="33.1276"
                  rx="33.6308"
                  ry="33.819"
                  transform="rotate(90 27.9928 33.1276)"
                  fill="#41FFDD"
                />
              </g>
            </g>
            <path
              d="M5.00168e-06 16.9917L2.20415e-06 48.9917L28 65L56 48.9917L56 16.9917L28 0.999999L5.00168e-06 16.9917Z"
              stroke="url(#paint1_linear_8100_34728)"
              strokeWidth="0.334392"
              strokeMiterlimit="10"
            />
          </g>
        </g>
        {!!border && (
          <path
            d="M0.500005 16.9917L0.500002 48.9917L28.5 65L56.5 48.9917L56.5 16.9917L28.5 0.999999L0.500005 16.9917Z"
            stroke="#00FFF7"
            strokeMiterlimit="10"
          />
        )}
        <defs>
          <linearGradient
            id="paint0_linear_8100_34728"
            x1="28"
            y1="65"
            x2="28"
            y2="0.999998"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#006E5A" />
            <stop offset="1" stopColor="#011D18" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_8100_34728"
            x1="28.0001"
            y1="-857.27"
            x2="28.0001"
            y2="-857.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.19" stopColor="#41FFDD" />
            <stop offset="0.76" stopColor="#41FFDD" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
      {!!children && <Children>{children}</Children>}
    </Root>
  );
};
